// frontend/src/components/pagos/PanelPagos.jsx
import React, { useState, useEffect, useCallback, useRef } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';

function getToken() { return localStorage.getItem('calleb_token'); }
function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

function fmt(val) { return `$${parseFloat(val||0).toFixed(2)}`; }
function formatFecha(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-VE',
    { day:'2-digit', month:'short', year:'numeric' });
}

const METODO_COLOR = {
  TRANSFERENCIA:{ bg:'#eff6ff', color:'#1d4ed8' },
  EFECTIVO:     { bg:'#f0fdf4', color:'#15803d' },
  ZELLE:        { bg:'#fdf4ff', color:'#7e22ce' },
  CHEQUE:       { bg:'#fff7ed', color:'#c2410c' },
  OTRO:         { bg:'#f8fafc', color:'#475569' },
};

// ── Modal editar pago ─────────────────────────────────────
function ModalEditarPago({ pago, onClose, onGuardado }) {
  const [form, setForm] = useState({
    fecha_pago:  pago.fecha_pago?.slice(0,10) || '',
    monto:       pago.monto || '',
    metodo:      pago.metodo || 'EFECTIVO',
    referencia:  pago.referencia || '',
    notas:       pago.notas || '',
  });
  const [guardando, setGuardando] = useState(false);
  const [error,     setError]     = useState(null);
  const set = (k,v) => setForm(f => ({ ...f, [k]:v }));

  const handleGuardar = async () => {
    setGuardando(true); setError(null);
    try {
      const res = await fetch(`${API}/pagos/${pago.id}`, {
        method: 'PUT',
        headers: { 'Content-Type':'application/json', ...authHeaders() },
        body: JSON.stringify({ ...form, monto: parseFloat(form.monto) }),
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      onGuardado();
    } catch(e) { setError(e.message); }
    finally { setGuardando(false); }
  };

  const handleEliminar = async () => {
    if (!window.confirm(`¿Eliminar el pago ${pago.numero_recibo}?\nEsta acción no se puede deshacer.`)) return;
    setGuardando(true);
    try {
      const res = await fetch(`${API}/pagos/${pago.id}`, {
        method:'DELETE', headers: authHeaders(),
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      onGuardado();
    } catch(e) { setError(e.message); }
    finally { setGuardando(false); }
  };

  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.45)',
        display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:16,
          padding:28, width:'100%', maxWidth:420, boxShadow:'0 20px 60px rgba(0,0,0,.25)' }}>
        <h3 style={{ fontSize:16, fontWeight:700, color:'#1a3a5c', marginBottom:4 }}>
          ✏️ Editar Pago
        </h3>
        <p style={{ fontSize:12, color:'#6b7280', marginBottom:20 }}>
          {pago.nombre_quinta} · {pago.numero_recibo}
        </p>
        {error && <div style={{ padding:'10px', background:'#fef2f2', color:'#dc2626',
                                borderRadius:8, marginBottom:14, fontSize:13 }}>⚠️ {error}</div>}
        <div style={{ display:'grid', gap:12 }}>
          <div>
            <label style={lbl}>Fecha</label>
            <input type="date" value={form.fecha_pago}
                   onChange={e=>set('fecha_pago',e.target.value)} style={inp}/>
          </div>
          <div>
            <label style={lbl}>Monto (USD)</label>
            <input type="number" step="0.01" value={form.monto}
                   onChange={e=>set('monto',e.target.value)} style={inp}/>
          </div>
          <div>
            <label style={lbl}>Método</label>
            <select value={form.metodo} onChange={e=>set('metodo',e.target.value)} style={inp}>
              {['TRANSFERENCIA','EFECTIVO','CHEQUE','ZELLE','OTRO'].map(m=>
                <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Referencia</label>
            <input type="text" value={form.referencia}
                   onChange={e=>set('referencia',e.target.value)} style={inp}/>
          </div>
          <div>
            <label style={lbl}>Notas</label>
            <input type="text" value={form.notas}
                   onChange={e=>set('notas',e.target.value)} style={inp}/>
          </div>
        </div>
        <div style={{ display:'flex', gap:8, marginTop:20 }}>
          <button onClick={handleEliminar} disabled={guardando}
                  style={{ ...btn, background:'#fef2f2', color:'#dc2626', flex:1 }}>
            🗑 Eliminar
          </button>
          <button onClick={onClose} style={{ ...btn, background:'#f3f4f6', color:'#374151', flex:1 }}>
            Cancelar
          </button>
          <button onClick={handleGuardar} disabled={guardando}
                  style={{ ...btn, background:'#1a3a5c', color:'#fff', flex:2 }}>
            {guardando ? 'Guardando…' : '💾 Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PanelPagos() {
  const anioActual = new Date().getFullYear();
  const [pagos,    setPagos]    = useState([]);
  const [total,    setTotal]    = useState(0);
  const [totalMonto,setTotalMonto]=useState(0);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [anio,     setAnio]     = useState(anioActual);
  const [editando, setEditando] = useState(null);
  const debounceRef = useRef(null);

  const anios = [anioActual, anioActual-1, anioActual-2];

  const cargar = useCallback(async (bus=busqueda, a=anio) => {
    setLoading(true); setError(null);
    try {
      const qs = new URLSearchParams({ anio:a, ...(bus?{busqueda:bus}:{}) });
      const res  = await fetch(`${API}/pagos?${qs}`, { headers:authHeaders() });
      const data = await res.json();
      if (!data.ok) throw new Error(data.mensaje);
      setPagos(data.pagos||[]);
      setTotal(data.total||0);
      setTotalMonto(data.total_monto||0);
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  }, [busqueda, anio]);

  useEffect(() => { cargar('', anioActual); }, []);
  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => cargar(busqueda, anio), 350);
    return () => clearTimeout(debounceRef.current);
  }, [busqueda, anio]);

  return (
    <div style={{ padding:24 }}>
      <div style={{ display:'flex', justifyContent:'space-between',
                    alignItems:'flex-start', flexWrap:'wrap', gap:12, marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:20, fontWeight:700, color:'#1a3a5c', margin:0 }}>
            💳 Historial de Pagos
          </h2>
          <p style={{ fontSize:12, color:'#6b7280', margin:'4px 0 0' }}>
            {total} pagos · Total: <strong style={{ color:'#15803d' }}>{fmt(totalMonto)}</strong>
          </p>
        </div>
        <select value={anio} onChange={e=>setAnio(parseInt(e.target.value))} style={inp}>
          {anios.map(a=><option key={a} value={a}>{a}</option>)}
        </select>
      </div>

      <input type="text" placeholder="🔍 Buscar por quinta o propietario…"
             value={busqueda} onChange={e=>setBusqueda(e.target.value)}
             style={{ ...inp, width:'100%', maxWidth:400, marginBottom:16, boxSizing:'border-box' }}/>

      {error && <div style={{ padding:12, background:'#fef2f2', color:'#dc2626',
                              borderRadius:8, marginBottom:16, fontSize:13 }}>⚠️ {error}</div>}

      <div style={{ background:'#fff', borderRadius:12,
                    boxShadow:'0 1px 4px rgba(0,0,0,.08)', overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:700 }}>
          <thead>
            <tr style={{ background:'#f8fafc' }}>
              {['Fecha','Quinta','Propietario','Recibo','Método','Monto',''].map(h=>(
                <th key={h} style={{ padding:'10px 12px', textAlign:'left', fontSize:11,
                                     fontWeight:600, color:'#6b7280',
                                     borderBottom:'2px solid #e5e7eb' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>
                Cargando…</td></tr>
            ) : pagos.length===0 ? (
              <tr><td colSpan={7} style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>
                No se encontraron pagos.</td></tr>
            ) : pagos.map(p => {
              const mc = METODO_COLOR[p.metodo]||METODO_COLOR.OTRO;
              return (
                <tr key={p.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                  <td style={td}>{formatFecha(p.fecha_pago)}</td>
                  <td style={{ ...td, fontWeight:600, color:'#1a3a5c' }}>{p.nombre_quinta}</td>
                  <td style={{ ...td, color:'#6b7280', fontSize:12 }}>{p.propietario}</td>
                  <td style={{ ...td, color:'#9ca3af', fontSize:11 }}>{p.numero_recibo}</td>
                  <td style={td}>
                    <span style={{ background:mc.bg, color:mc.color,
                                   padding:'2px 8px', borderRadius:12,
                                   fontSize:11, fontWeight:500 }}>{p.metodo}</span>
                  </td>
                  <td style={{ ...td, fontWeight:700, color:'#15803d' }}>{fmt(p.monto)}</td>
                  <td style={td}>
                    <button onClick={()=>setEditando(p)}
                            style={{ ...btn, background:'#f3f4f6', color:'#374151',
                                     padding:'4px 10px', fontSize:11 }}>
                      ✏️ Editar
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
          {pagos.length>0 && (
            <tfoot>
              <tr style={{ background:'#f8fafc', borderTop:'2px solid #e5e7eb' }}>
                <td colSpan={5} style={{ padding:'10px 12px', fontWeight:700,
                                         fontSize:13, color:'#374151' }}>Total {anio}</td>
                <td colSpan={2} style={{ padding:'10px 12px', fontWeight:700,
                                         color:'#15803d', fontSize:14 }}>{fmt(totalMonto)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>

      {editando && (
        <ModalEditarPago pago={editando} onClose={()=>setEditando(null)}
                         onGuardado={()=>{ setEditando(null); cargar(busqueda,anio); }}/>
      )}
    </div>
  );
}

const inp = { padding:'8px 12px', borderRadius:8, border:'1px solid #d1d5db',
              fontSize:13, background:'#fff', color:'#374151', width:'100%', boxSizing:'border-box' };
const lbl = { display:'block', fontSize:11, fontWeight:600, color:'#374151', marginBottom:4 };
const btn = { border:'none', borderRadius:8, padding:'8px 14px', fontSize:12,
              cursor:'pointer', fontWeight:600 };
const td  = { padding:'10px 12px', verticalAlign:'middle', fontSize:13 };
